// copied from https://code.tls.nuskin.io/ns-am/pasture/shop/forms/-/blob/9a769932a05a089b489dbd623eba2a3174f7313a/src/main/java/com/nse/forms/validation/rules/SGNRICValidator.java

export default function sgnricValidate(dataStr) {
  let valid = false;
  const regex = /^[STFG]{1}[\d]{7}[A-Z]{1}$/;
  const data = dataStr.toUpperCase();

  if (data.match(regex)) {
    const firstLetter = data.substring(0, 1);
    const firstDigit = Number(data.substring(1, 2)) * 2;
    const secondDigit = Number(data.substring(2, 3)) * 7;
    const thirdDigit = Number(data.substring(3, 4)) * 6;
    const fourthDigit = Number(data.substring(4, 5)) * 5;
    const fifthDigit = Number(data.substring(5, 6)) * 4;
    const sixthDigit = Number(data.substring(6, 7)) * 3;
    const seventhDigit = Number(data.substring(7, 8)) * 2;
    const lastLetter = data.substring(8, 9);

    let allDigits =
      firstDigit +
      secondDigit +
      thirdDigit +
      fourthDigit +
      fifthDigit +
      sixthDigit +
      seventhDigit;

    const sumDigits = allDigits;

    if (firstLetter === 'T' || firstLetter === 'G') {
      allDigits = sumDigits + 4;
    }
    // console.log("All digits = " +allDigits);

    const remainder = allDigits % 11;
    // console.log("Remainder = " +remainder);

    if (firstLetter === 'S' || firstLetter === 'T') {
      if (
        (remainder === 0 && lastLetter === 'J') ||
        (remainder === 1 && lastLetter === 'Z') ||
        (remainder === 2 && lastLetter === 'I') ||
        (remainder === 3 && lastLetter === 'H') ||
        (remainder === 4 && lastLetter === 'G') ||
        (remainder === 5 && lastLetter === 'F') ||
        (remainder === 6 && lastLetter === 'E') ||
        (remainder === 7 && lastLetter === 'D') ||
        (remainder === 8 && lastLetter === 'C') ||
        (remainder === 9 && lastLetter === 'B') ||
        (remainder === 10 && lastLetter === 'A')
      ) {
        valid = true;
      }
    }
    if (firstLetter === 'F' || firstLetter === 'G') {
      // if (
      //     (remainder === 0 && lastLetter === "X") ||
      //     (remainder === 1 && lastLetter === "W") ||
      //     (remainder === 2 && lastLetter === "U") ||
      //     (remainder === 3 && lastLetter === "T") ||
      //     (remainder === 4 && lastLetter === "R") ||
      //     (remainder === 5 && lastLetter === "Q") ||
      //     (remainder === 6 && lastLetter === "P") ||
      //     (remainder === 7 && lastLetter === "N") ||
      //     (remainder === 8 && lastLetter === "M") ||
      //     (remainder === 9 && lastLetter === "L") ||
      //     (remainder === 10 && lastLetter === "K")
      // ) {
      //     valid = true;
      // }
    }
  }
  return valid;
}
